import { RouterProvider, createRouter } from '@tanstack/react-router';
import { routeTree } from '@/routeTree.gen';
import { queryClient } from './QueryProvider';
import { useContext } from 'react';
import { AuthContext } from '@/context/authContext';
import { Loader } from '@/components/ui/loader';

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  scrollRestoration: true,
  trailingSlash: 'never',
  context: {
    queryClient,
    auth: {
      username: '',
      loginSession: '',
      tokens: null,
      isLoading: true,
    },
  },
  // Since we're using React Query, we don't want loader calls to ever be stale
  // This will ensure that the loader is always called when the route is preloaded or visited
  defaultPreloadStaleTime: 0,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export function AppRouterProvider() {
  const { username, loginSession, tokens, isLoading } = useContext(AuthContext);

  if (isLoading) {
    return (
      <div className="w-full h-dvh flex justify-center items-center">
        <Loader className="text-text-brand" />
      </div>
    );
  }

  return (
    <RouterProvider
      router={ router }
      context={ { auth: { username, loginSession, tokens, isLoading } } }
    />
  );
}
